import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from "../utils/util"
import { USER_ROLE, MESSAGE_SEND_FROM } from "../constants/index"
import {
  type ChatIsFlagRetrieveData,
  type ChatJobRecommendListData,
  type ChatMessageStaffListData,
  ChatService, type ChatStaffConventionListData,
  type ChatStaffMessageCreateData, type ChatTalentConventionListData,
  type ChatTalentJobRecommendListData,
  type ChatTalentMessageCreateData,
  type ChatTalentRecommendListData,
  type ChatMessageTalentListData, ChatActionsRetrieveData,
  type ChatUpdateConversationInfoCreateData, type ChatUpdateConversationTalentInfoCreateData,
  type ChatTalentRetrieveData
} from "api";
import i18n from 'i18next';
import { resetAppState } from "../store/common";

// Get list chat company
export type GetListChatCompanyArgs = ChatStaffConventionListData & {
  isSilent?: boolean;
};

export const getListChatCompany = createAsyncThunk(
  "getListChatCompany",
  async ({ isSilent, ...apiParams }: GetListChatCompanyArgs, thunkAPI: any) => {
    try {
      const res = await ChatService.chatStaffConventionList(apiParams) as any;
      if (res) { return res; }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);
// Get list chat talent
export const getListChatTalent = createAsyncThunk(
  "getListChatTalent",
  async (data: ChatTalentConventionListData, thunkAPI: any) => {
    try {
      const res = await ChatService.chatTalentConventionList(data) as any;
      if (res) { return res; }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);
// Get list talent recommend
export const getListTalentRecommend = createAsyncThunk(
  "getListTalentRecommend",
  async (data: ChatTalentRecommendListData, thunkAPI: any) => {
    try {
      const res = await ChatService.chatTalentRecommendList(data) as any;
      if (res) { return res; }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);
// Get list job recommend
export const getListJobRecommend = createAsyncThunk(
  "getListJobRecommend",
  async (data: ChatJobRecommendListData, thunkAPI: any) => {
    try {
      const res = await ChatService.chatJobRecommendList(data) as any;
      if (res) { return res; }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);
// Get list job recommend for talent
export const getListJobRecommendTalent = createAsyncThunk(
  "getListJobRecommendTalent",
  async (data: ChatTalentJobRecommendListData, thunkAPI: any) => {
    try {
      const res = await ChatService.chatTalentJobRecommendList(data) as any;
      if (res) { return res; }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);
// Get detail talent
export const getDetailTalentChat = createAsyncThunk(
  "getDetailTalentChat",
  async (data: ChatTalentRetrieveData, thunkAPI: any) => {
    try {
      const res = await ChatService.chatTalentRetrieve(data) as any;
      if (res) { return res; } else { return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED')); }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);
// Send message
export const sendMessage = createAsyncThunk(
  "sendMessage",
  async (data: ChatStaffMessageCreateData, thunkAPI: any) => {
    try {
      const res = await ChatService.chatStaffMessageCreate(data) as any;
      if (res) { return res; } else { return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED')); }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);
// Talent send message
export const talentSendMessage = createAsyncThunk(
  "talentSendMessage",
  async (data: ChatTalentMessageCreateData, thunkAPI: any) => {
    try {
      const res = await ChatService.chatTalentMessageCreate(data) as any;
      if (res) { return res; } else { return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED')); }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);
// Get list messages staff by convention
export const getMessages = createAsyncThunk(
  "getMessages",
  async (data: ChatMessageStaffListData, thunkAPI: any) => {
    try {
      const res = await ChatService.chatMessageStaffList(data) as any;
      if (res) { return res; } else { return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED')); }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);
// Get list actions related chat conversation
export const getActions = createAsyncThunk(
  "getActions",
  async (data: ChatActionsRetrieveData, thunkAPI: any) => {
    try {
      const res = await ChatService.chatActionsRetrieve(data) as any;
      if (res) { return res; } else { return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED')); }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);
// Get list messages talent by convention
export const getTalentMessages = createAsyncThunk(
  "getTalentMessages",
  async (data: ChatMessageTalentListData, thunkAPI: any) => {
    try {
      const res = await ChatService.chatMessageTalentList(data) as any;
      if (res) { return res; } else { return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED')); }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);
// Get number of messages not readed
export const getNumberMessages = createAsyncThunk(
  "getNumberMessages",
  async (_, thunkAPI: any) => {
    try {
      const res = await ChatService.chatMessageNumberRetrieve() as any;
      if (res) { return res; } else { return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED')); }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);
// Get number of messages not readed of talent
export const getNumberMessagesTalent = createAsyncThunk(
  "getNumberMessagesTalent",
  async (_, thunkAPI: any) => {
    try {
      const res = await ChatService.chatTalentMessageNumberRetrieve() as any;
      if (res) { return res; } else { return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED')); }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);
// Update convention is_flag
export const updateConventionIsFlag = createAsyncThunk(
  "updateConventionIsFlag",
  async (data: ChatIsFlagRetrieveData, thunkAPI: any) => {
    try {
      const res = await ChatService.chatIsFlagRetrieve(data) as any;
      if (res) { return res; } else { return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED')); }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);
// Update convention job
export const updateConventionJob = createAsyncThunk(
  "updateConventionJob",
  async (data: ChatUpdateConversationInfoCreateData, thunkAPI: any) => {
    try {
      const res = await ChatService.chatUpdateConversationInfoCreate(data) as any;
      if (res) { return res; } else { return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED')); }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);
// Update convention job
export const updateTalentConventionJob = createAsyncThunk(
  "updateTalentConventionJob",
  async (data: ChatUpdateConversationTalentInfoCreateData, thunkAPI: any) => {
    try {
      const res = await ChatService.chatUpdateConversationTalentInfoCreate(data) as any;
      if (res) { return res; } else { return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED')); }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);
// State ban đầu của Redux
interface ChatMessageState {
  loading: boolean; loadingGetListChat: boolean; error: string | null; actionStatus: string; actionName: string; isSuccess: boolean;
  chatList: any; chatSelected: any; isChatting: boolean; isScout: boolean; talentSelected: any;
  staffSelected: any; jobSelected: any; listTalentRecommend: any; listJobRecommend: any;
  isOpenListJobPanel: boolean; messages: any; numberOfMessage: any; action: any; actionItems: any; 
  numberOfTalentMessage: any; isFirstLoadListChat: boolean; isOpenChatListModal:boolean;
  isNewChatFormOtherScreen:boolean; page: number; pageSize: number; totalCons: number;
  isPaging: boolean; isSameChatSelected: boolean; isLoadNewListChat: boolean; messageSendFrom: string; isNewChat: boolean; 
  textInput: string; isDiscardUnsentMessagePopup: boolean; pendingPath: string; globalFilterString: string; isMessageFormDirty: boolean;
  files?: any[];
  isFlagFilter: boolean;
}
const initialState: ChatMessageState = {
  loading: false, loadingGetListChat: false, error: null, actionStatus: "idle", actionName: "", isSuccess: true, chatList: [],
  chatSelected: {}, isChatting: false, isScout: false, talentSelected: {}, staffSelected: {},
  jobSelected: {}, listTalentRecommend: [], listJobRecommend: [], isOpenListJobPanel: false,
  messages: [], action: {}, actionItems: [], numberOfMessage: 0, numberOfTalentMessage: 0, isFirstLoadListChat: true,
  isOpenChatListModal: true, isNewChatFormOtherScreen: false, page: 1, pageSize: 15, totalCons: 0,
  isPaging: true, isSameChatSelected: true,
  totalJobRecommend: 0,
  hasMore: true,
  currentPageLoading: 1,
  pageSizeLoading: 10,
  isLoadNewListChat: true,
  messageSendFrom: MESSAGE_SEND_FROM.CHAT,
  isNewChat: false,
  textInput: "",
  isDiscardUnsentMessagePopup: false,
  pendingPath: "",
  pageSizeLoadingJobRec: 15,
  globalFilterString: "",
  isMessageFormDirty: false,
  files: [],
  isNewCompanyConversation: false,
  isNewTalentConversation: false,
  isFlagFilter: false,
};
// Tạo slice với các reducers và extraReducers (cho async action)
export const chatMessageSlice = createSlice({
  name: "chatMessageSlice",
  initialState,
  reducers: {
    setChatSelected: (state, action) => { state.chatSelected = action.payload; },
    setIsChatting: (state, action) => { state.isChatting = action.payload; },
    setTalentSelected: (state, action) => { state.talentSelected = action.payload; },
    setStaffSelected: (state, action) => { state.staffSelected = action.payload; },
    setJobSelected: (state, action) => { state.jobSelected = action.payload; },
    setIsScout: (state, action) => { state.isScout = action.payload; },
    setIsOpenListJobPanel: (state, action) => { state.isOpenListJobPanel = action.payload; },
    setMessages: (state, action) => { state.messages = action.payload; },
    setAction: (state, action) => { state.action = action.payload; },
    setActionItems: (state, action) => { state.actionItems = action.payload; },
    setNumberOfMessage: (state, action) => { state.numberOfMessage = action.payload; },
    setChatList: (state, action) => { state.chatList = action.payload; },
    setIsFirstLoadListChat: (state, action) => { state.isFirstLoadListChat = action.payload; },
    setOpenChatListModal: (state, action) => { state.isOpenChatListModal = action.payload; },
    setIsNewChatFormOtherScreen: (state, action) => { state.isNewChatFormOtherScreen = action.payload; },
    setPage: (state, action) => { state.page = action.payload; },
    setPageSize: (state, action) => { state.pageSize = action.payload; },
    setIsPaging: (state, action) => { state.isPaging = action.payload; },
    setLoadingGetListChat: (state, action) => { state.loadingGetListChat = action.payload; },
    setIsSameChatSelected: (state, action) => { state.isSameChatSelected = action.payload; },
    setHasMore: (state, action) => { state.hasMore = action.payload; },
    setCurrentPageLoading: (state, action) => { state.currentPageLoading = action.payload; },
    setIsLoadNewListChat: (state, action) => { state.isLoadNewListChat = action.payload; },
    setMessageSendFrom: (state, action) => { state.messageSendFrom = action.payload; },
    setIsNewChat: (state, action) => { state.isNewChat = action.payload; },
    setActionStatus: (state, action) => { state.actionStatus = action.payload; },
    setTextInput: (state, action) => { state.textInput = action.payload; },
    setIsDiscardUnsentMessagePopup: (state, action) => { state.isDiscardUnsentMessagePopup = action.payload; },
    setPendingPath: (state, action) => { state.pendingPath = action.payload; },
    setGlobalFilterString: (state, action) => {
      state.globalFilterString = action.payload !== null && action.payload !== undefined ? String(action.payload) : "";
    },
    setListJobRecommend: (state, action) => { state.listJobRecommend = action.payload; },
    setIsMessageFormDirty: (state, action) => { state.isMessageFormDirty = action.payload; },
    setFiles: (state, action) => { state.files = action.payload; },
    setIsNewCompanyConversation: (state, action) => { state.isNewCompanyConversation = action.payload; },
    setIsNewTalentConversation: (state, action) => { state.isNewTalentConversation = action.payload; },
    setIsFlagFilter: (state, action) => { state.isFlagFilter = action.payload; },
  },
  extraReducers: (builder) => {
    builder
      // reset state
      .addCase(resetAppState, () => initialState)

      // Get list chat staff
      .addCase(getListChatCompany.pending, (state, action) => {
        const isSilent = Boolean(action.meta.arg?.isSilent);
        if (!isSilent) {
          state.loading = true;
          state.loadingGetListChat = true;
        }
        state.error = null;
        state.actionName = "getListChatCompany";
        state.actionStatus = "pending";
      })
      .addCase(getListChatCompany.fulfilled, (state, action) => {
        state.loading = false; state.loadingGetListChat = false; state.actionName = "getListChatCompany";
        state.actionStatus = "fulfilled"; state.totalCons = action.payload.count;
        if (state.isPaging) {
          let data = state.chatList.concat(action.payload.results);
          const sortedData = [...data].sort((a, b) => new Date(b.last_message.send_at) - new Date(a.last_message.send_at));
          state.chatList = sortedData
        } else {
          state.chatList = action.payload.results;
        }
      })
      .addCase(getListChatCompany.rejected, (state, action) => {
        state.loading = false; state.loadingGetListChat = false; state.error = action.payload as string;
        state.actionName = "getListChatCompany"; state.actionStatus = "rejected"; })
      // Get list chat talent
      .addCase(getListChatTalent.pending, (state) => {
        state.loading = true; state.loadingGetListChat = true; state.error = null;
        state.actionName = "getListChatTalent"; state.actionStatus = "pending"; })
      .addCase(getListChatTalent.fulfilled, (state, action) => {
        state.loading = false; state.loadingGetListChat = false; state.actionName = "getListChatTalent";
        state.actionStatus = "fulfilled"; state.totalCons = action.payload.count;
        if (state.isPaging) {
          let data = state.chatList.concat(action.payload.results);
          const sortedData = [...data].sort((a, b) => new Date(b.last_message.send_at) - new Date(a.last_message.send_at));
          state.chatList = sortedData
        } else {
          state.chatList = action.payload.results;
        }
      })
      .addCase(getListChatTalent.rejected, (state, action) => {
        state.loading = false; state.loadingGetListChat = false; state.error = action.payload as string;
        state.actionName = "getListChatTalent"; state.actionStatus = "rejected"; })
      // Get list talent recommend
      .addCase(getListTalentRecommend.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "getListTalentRecommend"; state.actionStatus = "pending"; })
      .addCase(getListTalentRecommend.fulfilled, (state, action) => {
        state.loading = false; state.actionName = "getListTalentRecommend";
        state.actionStatus = "fulfilled"; state.listTalentRecommend = action.payload.data; })
      .addCase(getListTalentRecommend.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionName = "getListTalentRecommend"; state.actionStatus = "rejected"; })
      // Get list job recommend
      .addCase(getListJobRecommend.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "getListJobRecommend"; 
        state.actionStatus = "pending"; 
        state.hasMore = false; 
      })
      .addCase(getListJobRecommend.fulfilled, (state, action) => {
        state.loading = false; 
        state.actionName = "getListJobRecommend";
        state.actionStatus = "fulfilled";

        if(state.currentPageLoading == 1) state.listJobRecommend = [];

        let countPageLoading = 0;
        state.totalJobRecommend = action.payload.count;
        if(state.totalJobRecommend == 0) {
          state.currentPageLoading = 1;
          state.listJobRecommend = [];
        } else {
          const newItems = action.payload?.results?.data;
          if(newItems) {
            const merged = [...state.listJobRecommend, ...newItems];
            const uniqueMap = new Map();
            merged.forEach(item => {
              if (!uniqueMap.has(item.id)) {
                uniqueMap.set(item.id, item);
              }
            });
            state.listJobRecommend = Array.from(uniqueMap.values());           
            countPageLoading = Math.ceil(state.totalJobRecommend / state.pageSizeLoadingJobRec);
          }
        }
        
        if(state.currentPageLoading >= countPageLoading) state.hasMore = false;
        else state.hasMore = true;
      })
      .addCase(getListJobRecommend.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.payload as string;
        state.actionName = "getListJobRecommend"; 
        state.actionStatus = "rejected"; 
      })
      // Get list job recommend for talent
      .addCase(getListJobRecommendTalent.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "getListJobRecommendTalent"; 
        state.actionStatus = "pending"; 
        state.hasMore = false; 
      })
      .addCase(getListJobRecommendTalent.fulfilled, (state, action) => {
        state.loading = false; state.actionName = "getListJobRecommendTalent";
        state.actionStatus = "fulfilled";
        
        if(state.currentPageLoading == 1) state.listJobRecommend = [];

        let countPageLoading = 0;
        state.totalJobRecommend = action.payload.count;
        if(state.totalJobRecommend == 0) {
          state.currentPageLoading = 1;
          state.listJobRecommend = [];
        } else {
          const newItems = action.payload?.results?.data;
          if(newItems) {
            const merged = [...state.listJobRecommend, ...newItems];
            const uniqueMap = new Map();
            merged.forEach(item => {
              if (!uniqueMap.has(item.id)) {
                uniqueMap.set(item.id, item);
              }
            });
            state.listJobRecommend = Array.from(uniqueMap.values());           
            countPageLoading = Math.ceil(state.totalJobRecommend / state.pageSizeLoading);
          }
        }
        
        if(state.currentPageLoading >= countPageLoading) state.hasMore = false;
        else state.hasMore = true;
      })
      .addCase(getListJobRecommendTalent.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionName = "getListJobRecommendTalent"; state.actionStatus = "rejected";
      })
      // Get list job recommend
      .addCase(getDetailTalentChat.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "getDetailTalentChat"; state.actionStatus = "pending";
      })
      .addCase(getDetailTalentChat.fulfilled, (state, action) => {
        state.loading = false; state.actionName = "getDetailTalentChat";
        state.actionStatus = "fulfilled"; state.talentSelected = action.payload.data;
      })
      .addCase(getDetailTalentChat.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionName = "getDetailTalentChat"; state.actionStatus = "rejected";
      })
      // Send message
      .addCase(sendMessage.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "sendMessage"; state.actionStatus = "pending";
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.loading = false; state.actionName = "sendMessage";
        state.actionStatus = "fulfilled";
        state.isSuccess = action.payload.success
        if(!action.payload.success) {
          state.error = action.payload.message
        } else {
          state.error = null
        }
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionName = "sendMessage"; state.actionStatus = "rejected";
      })
      // Talent send message
      .addCase(talentSendMessage.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "talentSendMessage"; state.actionStatus = "pending";
      })
      .addCase(talentSendMessage.fulfilled, (state, action) => {
        state.loading = false; state.actionName = "talentSendMessage";
        state.actionStatus = "fulfilled";
      })
      .addCase(talentSendMessage.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionName = "talentSendMessage"; state.actionStatus = "rejected";
      })
      // Get list messages by convention
      .addCase(getMessages.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "getMessages"; state.actionStatus = "pending";
      })
      .addCase(getMessages.fulfilled, (state, action) => {
        state.loading = false; state.actionName = "getMessages";
        state.actionStatus = "fulfilled";
        if (state.chatSelected?.id && String(state.chatSelected.id) === String(action.meta.arg?.id)) {
          state.messages = action.payload.data;
        }
      })
      .addCase(getMessages.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionName = "getMessages"; state.actionStatus = "rejected";
      })
      // Get list actions
      .addCase(getActions.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "getActions"; state.actionStatus = "pending";
      })
      .addCase(getActions.fulfilled, (state, action) => {
        state.loading = false; state.actionName = "getActions";
        state.actionStatus = "fulfilled"; 
        const targetId = action.meta.arg?.chatConversationId ?? action.meta.arg?.id;
        if (state.chatSelected?.id && String(state.chatSelected.id) === String(targetId)) {
          if(action.payload.data) {
            state.action = action.payload.data.action;
            state.actionItems = action.payload.data.action_items;
          } else {
            state.action = {}
            state.actionItems = []
          }
        }
      })
      .addCase(getActions.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionName = "getActions"; state.actionStatus = "rejected";
      })
      // Get list messages by convention
      .addCase(getTalentMessages.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "getTalentMessages"; state.actionStatus = "pending";
      })
      .addCase(getTalentMessages.fulfilled, (state, action) => {
        state.loading = false; state.actionName = "getTalentMessages";
        state.actionStatus = "fulfilled";
        if (state.chatSelected?.id && String(state.chatSelected.id) === String(action.meta.arg?.id)) {
          state.messages = action.payload.data;
        }
      })
      .addCase(getTalentMessages.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionName = "getTalentMessages"; state.actionStatus = "rejected";
      })
      // Get number of messages not readed
      .addCase(getNumberMessages.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "getNumberMessages"; state.actionStatus = "pending";
      })
      .addCase(getNumberMessages.fulfilled, (state, action) => {
        state.loading = false; state.actionName = "getNumberMessages";
        state.actionStatus = "fulfilled"; state.numberOfMessage = action.payload.data;
      })
      .addCase(getNumberMessages.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionName = "getNumberMessages"; state.actionStatus = "rejected";
      })
      // Get number of messages not readed of talent
      .addCase(getNumberMessagesTalent.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "getNumberMessagesTalent"; state.actionStatus = "pending";
      })
      .addCase(getNumberMessagesTalent.fulfilled, (state, action) => {
        state.loading = false; state.actionName = "getNumberMessagesTalent";
        state.actionStatus = "fulfilled"; state.numberOfTalentMessage = action.payload.data;
      })
      .addCase(getNumberMessagesTalent.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionName = "getNumberMessagesTalent"; state.actionStatus = "rejected";
      })
      // Update convention is_flag
      .addCase(updateConventionIsFlag.pending, (state) => {
        state.loading = true; state.error = null;
        state.actionName = "updateConventionIsFlag"; state.actionStatus = "pending";
      })
      .addCase(updateConventionIsFlag.fulfilled, (state, action) => {
        state.loading = false; state.actionName = "updateConventionIsFlag";
        state.actionStatus = "fulfilled";
      })
      .addCase(updateConventionIsFlag.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string;
        state.actionName = "updateConventionIsFlag"; state.actionStatus = "rejected";
      })
      // Update convention job
      .addCase(updateConventionJob.pending, (state) => {
        state.loading = true; state.error = null; state.actionStatus = "pending";
      })
      .addCase(updateConventionJob.fulfilled, (state, action) => {
        state.loading = false; state.actionName = "updateConventionJob"; state.actionStatus = "fulfilled";
      })
      .addCase(updateConventionJob.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string; state.actionStatus = "rejected";
      })
      // Update talent convention job
      .addCase(updateTalentConventionJob.pending, (state) => {
        state.loading = true; state.error = null; state.actionStatus = "pending";
      })
      .addCase(updateTalentConventionJob.fulfilled, (state, action) => {
        state.loading = false; state.actionName = "updateTalentConventionJob"; state.actionStatus = "fulfilled";
      })
      .addCase(updateTalentConventionJob.rejected, (state, action) => {
        state.loading = false; state.error = action.payload as string; state.actionStatus = "rejected";
      });
  },
});
export const { setChatSelected, setIsChatting, setTalentSelected, setStaffSelected, setJobSelected,
  setIsScout, setIsOpenListJobPanel, setMessages, setActions, setNumberOfMessage, setChatList, setIsFirstLoadListChat,
  setOpenChatListModal, setIsNewChatFormOtherScreen, setPage, setIsPaging, setLoadingGetListChat,
  setIsSameChatSelected, setPageSize, setCurrentPageLoading, setHasMore, setIsLoadNewListChat, setMessageSendFrom,
  setIsNewChat, setActionItems, setAction, setActionStatus, setTextInput, setIsDiscardUnsentMessagePopup, setPendingPath,
  setGlobalFilterString, setListJobRecommend, setIsMessageFormDirty, setFiles, setIsNewCompanyConversation,
  setIsNewTalentConversation, setIsFlagFilter
} = chatMessageSlice.actions;
export default chatMessageSlice.reducer;